// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + chunkId + ".js?v=" + {"1642":"0e50a2b32d2d64b50afa","5706":"3153330af47fc26a725a","6127":"374a617a5ed71ccd7362"}[chunkId] + "";
};